// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"dc64a669","932":"d55df9c7"}[chunkId] + ".chunk.js";
};